import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import ar from './locales/ar.json'
import darija from './locales/darija.json'
import fr from './locales/fr.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      ar: { translation: ar },
      darija: { translation: darija },
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],

      lookupLocalStorage: 'i18nextLng',
    },
    fallbackLng: 'fr',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  })
